<template>
  <div class="wrap">
    <div class="myVue" v-cloak>
      <!-- 提示  -->
      <div class="saasTipBox" v-if="saasTipFalg">
        <div class="saasTip">
          <span>{{saasTipText}}</span>
        </div>
      </div>
      <div class="queryBgView" v-show="queryViewFalg==1">
          <div class="queryView">
            <div class="queryLeft"></div>
            <div class="queryRight">
              <div class="queryInfo">
                <div class="queryTitle">
                  <div class="iconImg">
                    <img :src="biaoshiImg" />
                  </div>
                  <div class="title">
                    <span>注册河北烹饪(服务)大师名师证书查询</span>
                  </div>
                </div>
                <div class="queryTip">
                  <span>以下三项任意输入两项内容即可查询</span>
                </div>
                <div class="inputInfo">
                  <div class="tipDesc">
                    <span>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</span>
                  </div>
                  <div class="inputBox">
                    <input type="text" v-model="userNameVal" placeholder="请输入您的姓名" name id value />
                  </div>
                </div>
                <div class="inputInfo">
                  <div class="tipDesc">
                    <span>身份证号：</span>
                  </div>
                  <div class="inputBox">
                    <input type="text" v-model="idCardVal" placeholder="请输入您的身份证" name id value />
                  </div>
                </div>
                <div class="inputInfo">
                  <div class="tipDesc">
                    <span>证书编号：</span>
                  </div>
                  <div class="inputBox">
                    <input type="text" v-model="certNumVal" placeholder="请输入您的证书编号" name id value />
                  </div>
                </div>
                <div class="queryBtn">
                  <span @click="queryBtn">查询</span>
                </div>
              </div>
            </div>
          </div>
         
    
      </div>
       <div class="footer" v-show="queryViewFalg==1">
            <div class="leftText">
              <span>河北省饭店烹饪餐饮行业协会 版权所有 ICP证：</span>
            </div>
            <div class="rightText">
              <span><a href="http://www.beian.miit.gov.cn" target="_blank">冀ICP备19032344号</a></span>
            </div>
       </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userNameVal: "", //姓名
      idCardVal: "", //身份证书
      certNumVal: "", //证书编号
      queryViewFalg: 1, //1查询	2结果
      saasTipFalg: false, //提示框开关
      saasTipText: "", //提示的文本
      saasTipTimer: "", //提示时间的timer
      queryInfo: "", //查询信息
      biaoshiImg: require("@/assets/biaoshi.png")
    };
  },
  methods: {
    queryBtn() {
      var setNum = 0;
      if (this.userNameVal) {
        setNum++;
      }
      if (this.idCardVal) {
        setNum++;
      }
      if (this.certNumVal) {
        setNum++;
      }
      if (setNum < 2) {
        this.saasTipText = "您至少需要输入两项内容信息~";
        this.timerFun(this); //提示延时
      } else {
        let that = this;
        this.$http
          .get("/zsgl-service/zsglController/getZsxxByParamNotPage", {
            params: {
              xm: that.userNameVal,
              sfzh: that.idCardVal,
              zsbh: that.certNumVal
            }
          })
          .then(res => {
            if (res.data.result.length != 0) {
              console.log(res.data.result);
              this.$store.commit("setcxjg", res.data.result);
              this.$router.push("/cxjg");
            } else {
              that.saasTipText = "暂无结果，请耐心等待~";
              this.timerFun(that); //提示延时
            }
          });
      }
    },
    timerFun(that) {
      that.saasTipFalg = true;
      clearTimeout(that.saasTipTimer); //清楚计时器
      that.saasTipTimer = setTimeout(function() {
        that.saasTipFalg = false;
      }, 2000);
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cxcs.vue